(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layena-password"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('layena-countdown')) {

  customElements.define(
    'layena-countdown',

    class extends HTMLElement {

      connectedCallback() {

        this.timer =
          this.querySelector('[data-timer]');

        this.ended =
          this.querySelector('[data-ended]');

        this.units =
          ['days','hours','minutes','seconds'].map(
            unit =>
              this.querySelector(
                `[data-unit="${unit}"]`
              )
          );


        const raw =
          this.dataset.deadline || '';

        this.deadline =
          Date.parse(raw);


        const valid =
          /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(raw)
          &&
          Number.isFinite(this.deadline);


        if (!valid) {

          const invalid =
            this.querySelector('[data-invalid]');


          if (invalid) {

            invalid.hidden =
              !this.hasAttribute('data-editor');

          }

          return;
        }


        this.onVisibility =
          () => {

            if (!document.hidden) {
              this.tick();
            }

          };


        document.addEventListener(
          'visibilitychange',
          this.onVisibility
        );


        if (this.tick()) {

          this.interval =
            setInterval(
              () => this.tick(),
              1000
            );

        }


        const feedback =
          this.closest('.ly-launch')
            ?.querySelector('[data-feedback]');


        if (
          feedback
          &&
          !this.hasAttribute('data-editor')
        ) {

          feedback.focus();

        }

      }


      tick() {

        const remaining =
          Math.max(
            0,
            Math.ceil(
              (this.deadline - Date.now())
              /
              1000
            )
          );


        if (!remaining) {

          this.timer.hidden = true;
          this.ended.hidden = false;

          clearInterval(this.interval);

          return false;
        }


        const values = [

          Math.floor(
            remaining / 86400
          ),

          Math.floor(
            remaining / 3600
          ) % 24,

          Math.floor(
            remaining / 60
          ) % 60,

          remaining % 60

        ];


        values.forEach(
          (value,index) => {

            const unit =
              this.units[index];


            if (!unit) return;


            const text =
              String(value)
                .padStart(2,'0');


            if (
              unit.textContent
              !==
              text
            ) {

              unit.textContent =
                text;

            }

          }
        );


        this.timer.hidden = false;
        this.ended.hidden = true;

        return true;
      }


      disconnectedCallback() {

        clearInterval(this.interval);


        if (this.onVisibility) {

          document.removeEventListener(
            'visibilitychange',
            this.onVisibility
          );

        }

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();
})();
